import { render, staticRenderFns } from "./Transportistas.vue?vue&type=template&id=ba31f67e&"
import script from "./Transportistas.vue?vue&type=script&lang=js&"
export * from "./Transportistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports